module.exports = __webpack_public_path__ + "static/media/lifestyle.52254d52.jpg";